import { useState, useEffect, useRef } from 'react'
import { API, API_ROUTER } from '../../../../../api'
import getPublicGames from '../../../../../helpers/games/getPublicGames'

export const useUserGames = id => {
  const [games, setGames] = useState([])
  const [userPublicGames, setUserPublicGames] = useState([])
  const [requestSuccess, setRequestSuccess] = useState(false)
  const mountedRef = useRef(true)

  const getPublicUserGames = async () => {
    if (id === undefined || !mountedRef.current) {
      return
    }

    setRequestSuccess(false)
    try {
      const res = await getPublicGames(id)
      if (mountedRef.current) {
        setUserPublicGames(res.games)
        setRequestSuccess(true)
      }
    } catch (err) {
      console.log(err)
      if (mountedRef.current) {
        setRequestSuccess(true)
      }
    }
  }

  const getOwnerUserGames = async () => {
    if (!mountedRef.current) {
      return
    }
    setRequestSuccess(false)
    try {
      const res = await API.request({
        ...API_ROUTER.games.getUserGames,
      })
      if (mountedRef.current) {
        setGames(res.games)
        setRequestSuccess(true)
      }
    } catch (err) {
      console.log(err)
      if (mountedRef.current) {
        setRequestSuccess(true)
      }
    }
  }

  useEffect(() => {
    Promise.allSettled([getPublicUserGames(), getOwnerUserGames()])

    return () => {
      mountedRef.current = false
    }
  }, [id])

  return {
    games,
    userPublicGames,
    requestSuccess,
    setRequestSuccess,
    getPublicUserGames,
    getOwnerUserGames,
  }
}
